import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { mergeMap, of, take } from 'rxjs';
import { IPrefixSuffix } from 'src/app/shared/models/IPrefixSuffix';
import { IUserSession } from 'src/app/shared/models/IUserSession';
import { ResourcesService } from 'src/app/shared/services/resources.service';
import { OnlySpacesValidator } from 'src/app/shared/util/onlySpaces.validator';
import { FacilitiesService } from '../facilities/shared/facilities.service';
import { UserSessionService } from '../users/shared/user-session.service';
import { PrefixSuffixService } from './shared/prefix-suffix.service';
import { IPrefixSuffixFacility } from 'src/app/shared/models/IPrefixSuffixFacility';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { ContainsSpaceValidator } from 'src/app/shared/util/containsSpace.validator';
@Component({
  selector: 'app-prefix-suffix',
  templateUrl: './prefix-suffix.component.html',
  styleUrls: ['./prefix-suffix.component.css']
})
export class PrefixSuffixComponent implements OnInit {
  resourceKeyValue: any;
  isLoading = false;
  isCreate = false;
  isFacilityConfigured: boolean;
  lblNotAuthorizedInstruction1 = '';
  lblNotAuthorizedInstruction2 = '';
  currentSelectedFacilityID: number;
  facilities: IPrefixSuffixFacility[];
  allSelectedValue: IPrefixSuffixFacility;
  formControlFacilities: UntypedFormControl;
  selectedValueText = "";
  prefixSuffixForm = this.fb.group({
    id: ['-1', []],
    scannerPrefix: ['', [Validators.maxLength(50), OnlySpacesValidator.onlyWhiteSpace, ContainsSpaceValidator.containsWhiteSpace]],
    scannerSufffix: ['', [Validators.maxLength(50), OnlySpacesValidator.onlyWhiteSpace, ContainsSpaceValidator.containsWhiteSpace]],
    devicePrefix: ['', [Validators.maxLength(50), OnlySpacesValidator.onlyWhiteSpace, ContainsSpaceValidator.containsWhiteSpace]],
    deviceSufffix: ['', [Validators.maxLength(50), OnlySpacesValidator.onlyWhiteSpace, ContainsSpaceValidator.containsWhiteSpace]],
    patientPrefix: ['', [Validators.maxLength(50), OnlySpacesValidator.onlyWhiteSpace, ContainsSpaceValidator.containsWhiteSpace]],
    patientSufffix: ['', [Validators.maxLength(50), OnlySpacesValidator.onlyWhiteSpace, ContainsSpaceValidator.containsWhiteSpace]],
    patientSearchDelimeter: ['', [Validators.maxLength(50), OnlySpacesValidator.onlyWhiteSpace, ContainsSpaceValidator.containsWhiteSpace]],
    formControlFacilities: [new UntypedFormControl(), []]
  });

  constructor(private resourcesService: ResourcesService,
    private userSessionService: UserSessionService,
    private fb: UntypedFormBuilder,
    public toastrService: ToastrService,
    private router: Router,
    public prefixSuffixService: PrefixSuffixService,
    public facilitiesService: FacilitiesService) { }

  ngOnInit(): void {
    this.resourcesService.bsObject
      .subscribe((result: any) => {
        result && (this.resourceKeyValue = result);
        this.setAllItemsValue();
        this.getPrefixSuffix();
      });
  }

  getPrefixSuffix(): void {
    this.isLoading = true;
    this.userSessionService.getUserSession().pipe(
      take(1),
      mergeMap((userSessionDetail: IUserSession) => {
        if (userSessionDetail?.facilityId) {
          this.isFacilityConfigured = true;
          this.currentSelectedFacilityID = userSessionDetail.facilityId;
          return this.facilitiesService.getFacilitiesByIdnId(userSessionDetail.idnId);
        } else {
          this.isFacilityConfigured = false;
          this.setControlValues();
          return of([]);
        }
      }),
      mergeMap((facilities: IPrefixSuffixFacility[]) => {
        if (facilities && facilities.length > 0) {
          this.facilities = facilities;
          return this.prefixSuffixService.getPrefixSuffixByFacility(this.currentSelectedFacilityID);
        }
        return of(undefined);
      })
    ).subscribe((prefixSuffixData: IPrefixSuffix) => {
      if (prefixSuffixData) {
        var selectedFacility = this.facilities.find((facility: IPrefixSuffixFacility) => facility.id == this.currentSelectedFacilityID);
        var selectedFacilties = this.facilities.filter((facility: IPrefixSuffixFacility) => selectedFacility?.prefixSuffixId > 0 && facility.prefixSuffixId == selectedFacility?.prefixSuffixId);
        if (!selectedFacilties || selectedFacilties.length == 0) {
          selectedFacilties.push(selectedFacility);
        }

        if (selectedFacilties.length == this.facilities.length) {
          selectedFacilties.unshift(this.allSelectedValue);
        }
        this.prefixSuffixForm.patchValue({
          id: prefixSuffixData?.id,
          scannerPrefix: prefixSuffixData?.scannerPrefix,
          scannerSufffix: prefixSuffixData?.scannerSufffix,
          devicePrefix: prefixSuffixData?.devicePrefix,
          deviceSufffix: prefixSuffixData?.deviceSufffix,
          patientPrefix: prefixSuffixData?.patientPrefix,
          patientSufffix: prefixSuffixData?.patientSufffix,
          patientSearchDelimeter: prefixSuffixData?.patientSearchDelimeter,
          formControlFacilities: selectedFacilties
        });
        this.selectedValueText = selectedFacilties.filter(x => x.id != 0).map(y => y.name).join(', ');
        this.isCreate = prefixSuffixData.id == -1;
      }
      this.isLoading = false;
    },
      (error) => {
        if (error.code == 404) {
          this.isLoading = false;
          return;
        }
      });
  }

  addUpdatePrefixSuffix(): void {
    this.isLoading = true;
    var prefixSuffixRequest = this.createRequestObject(this.prefixSuffixForm);
    this.prefixSuffixService.createPrefixSuffix(prefixSuffixRequest).subscribe(response => {
      if (response) {
        this.router.navigate(['/idns']);
        this.isLoading = false;
        if (this.isCreate) {
          this.showSuccessNotification(this.resourceKeyValue.prefixSuffixSuccessMessageOnCreate);
        } else {
          this.showSuccessNotification(this.resourceKeyValue.prefixSuffixSuccessMessageOnUpdate);
        }
      } else {
        throw new Error('Failed to create Prefix Suffix');
      }
    }, (error: HttpErrorResponse) => {
      this.isLoading = false;
      //TODO: Add calling AI here.
      console.error(error);
      if (this.isCreate) {
        this.showErrorNotification(this.resourceKeyValue.prefixSuffixErrorMessageOnCreate);
      } else {
        this.showErrorNotification(this.resourceKeyValue.prefixSuffixErrorMessageOnUpdate);
      }
    });
  }

  toggleAllSelection(matSelect: MatSelect) {
    const isSelected: boolean = matSelect.options
      // The "Select All" item has the value 0, so find that one
      .filter((item: MatOption) => item.value.id === 0)
      // Get the value of the property 'selected' (this tells us whether "Select All" is selected or not)
      .map((item: MatOption) => item.selected)
    // Get the first element (there should only be 1 option with the value 0 in the select)
    [0];
    if (isSelected) {
      matSelect.options.forEach((item: MatOption) => {
        item.select();
      });

    } else {
      matSelect.options.forEach((item: MatOption) => {
        if (!item.disabled) {
          item.deselect();
        }
      });
    }
    this.setSelectedValues(matSelect);
  }

  togglePerOne(allSelected: MatOption, matSelect: MatSelect) {
    if (matSelect.options.some((item: MatOption) => item.value.id != 0 && !item.selected)) {
      allSelected.deselect();
    } else {
      allSelected.select();
    }
    this.setSelectedValues(matSelect);
  }

  createRequestObject(formGroup: UntypedFormGroup): IPrefixSuffix {
    var facilityRecordIds = (formGroup.get('formControlFacilities')!.value as IPrefixSuffixFacility[])?.filter(x => x.id != 0).map(x => x.id);
    let requestObj = {
      id: this.getTrimValue(formGroup, 'id'),
      scannerPrefix: this.getTrimValue(formGroup, 'scannerPrefix'),
      scannerSufffix: this.getTrimValue(formGroup, 'scannerSufffix'),
      devicePrefix: this.getTrimValue(formGroup, 'devicePrefix'),
      deviceSufffix: this.getTrimValue(formGroup, 'deviceSufffix'),
      patientPrefix: this.getTrimValue(formGroup, 'patientPrefix'),
      patientSufffix: this.getTrimValue(formGroup, 'patientSufffix'),
      patientSearchDelimeter: this.getTrimValue(formGroup, 'patientSearchDelimeter'),
      facilityRecordIds: facilityRecordIds
    }
    return requestObj;
  }

  getTrimValue(formGroup: UntypedFormGroup, fieldName: string) {
    const val = formGroup.get(fieldName).value;
    if (typeof val === "number") {
      return val;
    }
    else if (val !== undefined && val !== null) {
      return val.trim();
    }
    return "";
  }

  setControlValues(): void {
    this.lblNotAuthorizedInstruction1 = this.resourceKeyValue.lblNotAuthorizedInstruction3;
    this.lblNotAuthorizedInstruction2 = this.resourceKeyValue.lblNotAuthorizedInstruction4;
  }

  setAllItemsValue() {
    this.allSelectedValue = {
      id: 0,
      name: this.resourceKeyValue.optionSelectAll,
      idnId: 0,
      prefixSuffixId: 0
    };
  }

  setSelectedValues(matSelect: MatSelect) {
    this.selectedValueText = matSelect.options.filter((item: MatOption) =>
      item.selected && item.value.id != 0
    ).map(x => x.value.name).join(', ');
  }

  showSuccessNotification(message: string) {
    this.toastrService.success(message, this.resourceKeyValue.resourceKeyDeviceType, {
      timeOut: 3000,
      closeButton: true,
      positionClass: 'toast-top-center',
    });
  }

  showErrorNotification(message: string) {
    this.toastrService.error(message, this.resourceKeyValue.resourceKeyDeviceType, {
      timeOut: 3000,
      closeButton: true,
      positionClass: 'toast-top-center',
    });
  }
}
